"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = require("react");

var _moment = _interopRequireDefault(require("moment"));

var _lang = _interopRequireDefault(require("./lang"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var isDirty = function isDirty(value) {
  return value && value !== '';
};

var getCurrentValueFor = function getCurrentValueFor(value, language) {
  if (!value) {
    return '';
  }

  return (0, _moment["default"])(value).locale(language).format(_lang["default"][language].date);
};

var getMomentObjFor = function getMomentObjFor(currentValue) {
  if (currentValue === '') {
    return (0, _moment["default"])().startOf('day');
  }

  return (0, _moment["default"])(currentValue);
};

var reducer = function reducer(state, _ref) {
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case 'TOGGLE_ACTIVE':
      return _objectSpread(_objectSpread({}, state), {}, {
        active: !state.active
      });

    case 'UPDATE_DAY':
      return _objectSpread(_objectSpread({}, state), {}, {
        daySelected: payload.daySelected,
        month: payload.month
      });

    case 'SET_DIRTY':
      return _objectSpread(_objectSpread({}, state), {}, {
        dirty: payload
      });

    case 'NAVIGATE_MONTH':
      return _objectSpread(_objectSpread({}, state), {}, {
        month: payload === 'add' ? state.month.clone().add(1, 'month') : state.month.clone().subtract(1, 'month')
      });

    case 'SET_TODAY':
      return _objectSpread(_objectSpread({}, state), {}, {
        daySelected: (0, _moment["default"])().format('YYYY-MM-DD'),
        month: (0, _moment["default"])().startOf('month')
      });

    case 'ON_FOCUS':
      return _objectSpread(_objectSpread({}, state), {}, {
        daySelected: getMomentObjFor(state.daySelected).format('YYYY-MM-DD'),
        active: true
      });

    case 'ON_ACCEPT':
      return _objectSpread(_objectSpread({}, state), {}, {
        active: !state.active,
        currentValue: (0, _moment["default"])(state.daySelected).locale(state.language).format(_lang["default"][state.language].date),
        dirty: true
      });

    default:
      return state;
  }
};

var useCalendarReducer = function useCalendarReducer(_ref2) {
  var value = _ref2.value,
      language = _ref2.language;
  var initialState = {
    active: false,
    daySelected: null,
    dirty: isDirty(value),
    currentValue: getCurrentValueFor(value, language),
    month: (0, _moment["default"])().startOf('month'),
    language: language
  };

  var _useReducer = (0, _react.useReducer)(reducer, initialState),
      _useReducer2 = (0, _slicedToArray2["default"])(_useReducer, 2),
      state = _useReducer2[0],
      dispatch = _useReducer2[1];

  return _objectSpread(_objectSpread({}, state), {}, {
    dispatch: dispatch
  });
};

var _default = useCalendarReducer;
exports["default"] = _default;